/* Kleurnaam naar vakjeskleur, gedeeld door de collectiepagina en de productpagina (Vince
   2026-10-13). Shopify heeft voor geen enkele kleurwaarde een swatch ingevuld (gemeten
   2026-10-13: 72 van 72 leeg), dus deze lijst is de enige bron. Stond eerst in
   main-collection-3d4m.liquid. Gebruik: Kleur3D4M.hex(naam, swatch) en Kleur3D4M.naam(naam). */
(function () {
  var COLOR_ALIAS = { BK: 'Black', NT: 'Natural', GY: 'Grey', WH: 'White' };
  var COLOR_HEX = {
    natural: '#e5ddc8', black: '#1a1a1a', white: '#f4f4f0', grey: '#8c8c8c', gray: '#8c8c8c',
    silver: '#c0c0c0', blue: '#2b5b9e', red: '#b23b3b', green: '#3b7a4b', yellow: '#e0c23f',
    orange: '#e0812f', purple: '#7a4b9e', pink: '#d98bb0', brown: '#7a5230',
    transparent: '#dfe6e6', clear: '#dfe6e6', gold: '#c9a227',
    /* Op /de-de/ komen de kleurnamen in het Duits binnen (Translate & Adapt), dus die
       moeten hier ook staan; anders wordt elk bolletje de beige terugval (gemeten 2026-10-05). */
    natur: '#e5ddc8', 'natür': '#e5ddc8', schwarz: '#1a1a1a', 'weiß': '#f4f4f0', weiss: '#f4f4f0',
    grau: '#8c8c8c', silber: '#c0c0c0', blau: '#2b5b9e', rot: '#b23b3b', 'grün': '#3b7a4b',
    gelb: '#e0c23f', lila: '#7a4b9e', violett: '#7a4b9e', rosa: '#d98bb0', braun: '#7a5230', klar: '#dfe6e6'
  };
  function colorDisplayName(name) {
    if (COLOR_ALIAS[name]) return COLOR_ALIAS[name];
    return name.replace(/\s*\(RAL[^)]*\)/i, '').trim();
  }
  function colorHex(name, swatch) {
    if (swatch) return swatch;
    var key = colorDisplayName(name).toLowerCase();
    for (var w in COLOR_HEX) { if (key.indexOf(w) !== -1) return COLOR_HEX[w]; }
    return '#cfcabb';
  }
  window.Kleur3D4M = { naam: colorDisplayName, hex: colorHex };
})();
